module.exports = __webpack_public_path__ + "static/img/bread.40796d66.png";